import SupplierNoDownInvAPI from '../../api/SupplierNoDownInvAPI';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
export default {
	deleteSupNoDown: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SupplierNoDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/remove-supnodowninv',
			data: payload
		});
		return res;
	},

	addSupNoDown: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SupplierNoDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				data: payload
			},
			true
		);
		return res;
	},

	getPagingSupNoDown: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SupplierNoDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('setData', res.Data);
		}
		return res;
	},

	getTotalRecordSupNoDown: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SupplierNoDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/total'
			},
			true
		);
		if (res && res.Success) {
			context.commit('setTotalPage', res.Data);
		}
		return res;
	}
};
